import styled from "styled-components";
import { motion } from "framer-motion";
import { COLORS, fontMixins } from "../../../../../../../styles";

export const GLV_Container = styled(motion.div)`
	display: flex;
	flex-direction: column;
	row-gap: 25px;
	color: ${COLORS.Dark_Gray};
	${fontMixins(16)};
`;

export const groupLessonViewVariants = {
	hidden: {
		opacity: 0,
		x: 24,
		scale: 0.98,
	},
	visible: {
		opacity: 1,
		x: 0,
		scale: 1,
		transition: {
			duration: 0.28,
			ease: [0.16, 1, 0.3, 1],
			when: "beforeChildren",
			staggerChildren: 0.1,
			delayChildren: 0.08,
		},
	},
	exit: {
		opacity: 0,
		x: 24,
		scale: 0.98,
		transition: {
			duration: 0.18,
			ease: "easeOut",
		},
	},
};
